'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { pusdtAgreementBunja } from '@flipster/features/src/earn-page/get-premium-usdt/bunja';
import { earnStatisticsBunja, earnSummaryBunja } from '@flipster/features/src/shared/earn/state';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { PusdtCurrency } from '@flipster/utils/constants/currency';
import { convertDate } from '@flipster/utils/datetime';

import LatestUpdate from '../LatestUpdate';
import ActiveAprCard from './active-apr-card';
import InactiveAprCard from './inactive-apr-card';

const YourEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const { earnStatisticsAtom } = useBunja(earnStatisticsBunja);
  const { isAgreedPusdtAtom } = useBunja(pusdtAgreementBunja);

  const earnSummary = useAtomValue(earnSummaryAtom);
  const earnStatistics = useAtomValue(earnStatisticsAtom);
  const isAgreedPusdt = useAtomValue(isAgreedPusdtAtom);

  const latestUpdate = convertDate(earnStatistics?.aprUpdatedAt);

  return (
    <section className={stack({ gap: 20 })}>
      <div className={css({ textStyle: 'Title/M', color: 'content.default.level-4' })}>Your earnings</div>
      <div className={stack({ gap: 10 })}>
        {earnSummary?.currencies.map((c) => {
          const currency = c.currency;

          if (currency === PusdtCurrency && !isAgreedPusdt) {
            return <InactiveAprCard key={currency} currency={currency} />;
          }
          return <ActiveAprCard key={currency} currency={currency} />;
        })}
      </div>
      <LatestUpdate date={latestUpdate} />
    </section>
  );
};

export default YourEarnAprSection;
